/**
 * Extracts all the map entries as an array.
 */
export const entries = <T, U>(map: Map<T, U>) => {
	const e: Array<[T, U]> = [];
	for (const entry of map.entries()) {
		e.push(entry);
	}
	return e;
};
